module.exports = __webpack_public_path__ + "img/360mdrlogo.110915dd.png";